module.exports = __webpack_public_path__ + "img/yhq.37415325.png";